export default __webpack_public_path__ + "static/media/blog-img103.94b0cce4.jpg";